import Vue from "vue";
import { importAll } from "@/utils";

const requireContext = require.context("./", true, /\.vue$/);
const components = importAll(requireContext);

for (let key in components) {
  Vue.component(components[key].name, components[key]);
}
